<template>
  <Listbox
    v-slot="{ open }"
    as="div"
    by="slug"
    class="relative w-full"
    :model-value="modelValue"
    @update:model-value="(value) => emit('update:modelValue', value)"
  >
    <!-- HEADER -->
    <ListboxButton
      :id="`headlessui-listbox-button-${handle}`"
      v-slot="{ value }"
      class="w-full min-w-56 max-w-full"
    >
      <div
        class="
          flex w-full items-center justify-between gap-[0.25em] rounded-sm
          bg-gray-100 px-6 py-4
        "
      >
        <span class="truncate">
          {{ value || placeholder }}
        </span>
        <IconChevron
          v-if="!value"
          class="
            ml-1 size-7 shrink-0 -rotate-180 transition-all
            ui-open:rotate-0
            md:size-[1.5em]
          "
        />
        <IconCross
          v-else
          class="
            size-6 shrink-0
            md:size-[1em]
          "
          @click="emit('update:modelValue', '')"
        />
      </div>
    </ListboxButton>

    <!-- OPTIONS -->
    <Transition :open="open" name="fade">
      <ListboxOptions
        class="
          absolute top-full z-20 w-full min-w-56 max-w-full rounded bg-gray-200
          shadow
        "
      >
        <ListboxOption
          v-for="(option, index) in options"
          v-slot="{ active }"
          :key="index"
          :value="option"
          as="template"
        >
          <li
            class="w-full cursor-pointer px-6 py-3 transition-colors"
            :class="{
              'bg-gray-250': active,
            }"
          >
            {{ option }}
          </li>
        </ListboxOption>
      </ListboxOptions>
    </Transition>
  </Listbox>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from '@headlessui/vue'

defineProps({
  handle: {
    type: String, required: true,
  },
  placeholder: {
    type: String, default: 'jetzt wählen',
  },
  options: {
    type: Array, default: () => [],
  },
  modelValue: {
    type: String, default: '',
  },
})

const emit = defineEmits(['update:modelValue'])
</script>
